import { useEffect } from 'react'
import { useQuery } from 'react-query'

import { ErrorMessage } from 'infrastructure/shared/types'
import { postObjectsFilter } from 'shared/api'
import { TaskFilterResult } from 'task/shared/types'
import { buildTaskFromFilterResult } from 'task/shared/factories/taskFactory'
import { FilterResponse } from 'shared/types'

const payload = {
  query: {
    $and: [
      {
        $and: [
          {
            'situation.des': {
              $eq: '40'
            },
            'uuid_status.des': {
              $in: [
                window.waitingInteractionFillUUID,
                window.waitingTargetSituationUUID,
                window.waitingTargetStatusUUID
              ]
            }
          }
        ]
      }
    ]
  },
  orderby: [],
  objectclass: 'UUID_Objectclass_Task',
  pagination: {},
  visualization: 'classic-list'
}

const useTasks = () => {
  const { data, refetch, error } = useQuery<
    FilterResponse<TaskFilterResult>,
    ErrorMessage
  >(['object-by-id', payload], () => postObjectsFilter(payload, true), {
    enabled: false
  })

  useEffect(() => {
    refetch()
  }, [])

  useEffect(() => {
    if (error) console.log('error', error.message)
  }, [error])

  return data?.data.objects.map(buildTaskFromFilterResult) || []
}

export default useTasks
